// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lz-0";
export var fileList = "_lz-2";
export var removeFileButton = "_lz-1";